export const ContentTypeMap = {
  ContentfulWebinar: '/webinar/',
  ContentfulPodcast: '',
  ContentfulBlog: '/blog/',
  ContentfulGatedContentPage: '/guides/',
  ContentfulTools: '',
  Tools: '/',
};

export const ctaTypeMap = {
  ContentfulGatedContentPage: 'Download Now',
  ContentfulBlog: 'Read Now',
  ContentfulWebinar: 'Register Now',
  ContentfulPodcast: 'Listen Now',
  ContentfulTool: 'Use Tool Now',
};

export const ContentTypeCategory = {
  ContentfulWebinar: 'Webinar',
  ContentfulPodcast: 'Podcast',
  ContentfulBlog: 'Article',
  ContentfulGatedContentPage: 'Guide',
  ContentfulTool: 'Tool',
};

export const getImageSrc = img =>
  img.cardImage ||
  img.featuredImage?.image ||
  img.cardPhoto?.image ||
  img.coverPhoto?.image ||
  img.featuredImage ||
  img.assetThumbnail ||
  (img.speakers.length > 0 && img.speakers[0]?.photo?.imageMobile);

export const getImageAlt = img =>
  img.featuredImage?.title ||
  img.assetThumbnail?.title ||
  img.featuredImage?.alt ||
  img.cardPhoto?.alt ||
  img.coverPhoto?.alt;

export const getKicker = content => ContentTypeCategory[content.__typename];

export const getTitle = content =>
  content?.title ||
  content?.webinarTitle ||
  content?.podcastTitle ||
  content?.contentOfferTitle ||
  content?.internalName;

export const getExcerpt = content =>
  content?.excerpt?.excerpt || content?.excerpt?.content[0]?.content[0]?.value;

export const getMainContent = content =>
  content?.contentOfferMessage?.json || content?.mainContent?.json;

export const getCtaLink = content =>
  `${ContentTypeMap[content.__typename]}${content?.seo?.pageUrl || content?.slug}`;

export const getCtaLabel = content =>
  content.onDemandPage ? 'Watch Now' : `${ctaTypeMap[content.__typename]}`;

export const getCategories = data =>
  data?.category?.split(',')?.join(' • ') ||
  data?.taxonomy?.topics?.join(' • ') ||
  ContentTypeCategory[data.__typename] ||
  'Tools';
